module.exports = __webpack_public_path__ + "img/P5-zh.c7fc2fa5.png";